import request from '../utils/request'

/**
 * 创建菜单
 */
export function createMenu(data) {
  return request({
    url: '/admin/sys-menu',
    method: 'post',
    data
  })
}

/**
 * 更新菜单
 */
export function updateMenu(data) {
  return request({
    url: '/admin/sys-menu',
    method: 'put',
    data
  })
}

/**
 * 删除菜单
 */
export function deleteMenu(id) {
  return request({
    url: `/admin/sys-menu/${id}`,
    method: 'delete'
  })
}

/**
 * 根据ID获取菜单
 */
export function getMenuById(id) {
  return request({
    url: `/admin/sys-menu/${id}`,
    method: 'get'
  })
}

/**
 * 分页查询菜单列表
 */
export function getMenuList(params) {
  return request({
    url: '/admin/sys-menu/list',
    method: 'get',
    params
  })
}

/**
 * 获取菜单树
 */
export function getMenuTree(platformType) {
  return request({
    url: '/admin/sys-menu/tree',
    method: 'get',
    params: { platformType, _t: Date.now() },
    headers: {
      'Cache-Control': 'no-cache'
    }
  })
}

/**
 * 获取菜单树（供角色管理使用）
 * @param {String} platformType 平台类型
 * @param {Number} companyId 企业ID，如果指定则只返回该企业的菜单和公共菜单
 */
export function getMenuTreeForRole(platformType, companyId) {
  return request({
    url: '/admin/sys-menu/tree-for-role',
    method: 'get',
    params: { platformType, companyId, _t: Date.now() },
    headers: {
      'Cache-Control': 'no-cache'
    }
  })
}

/**
 * 获取用户菜单树
 */
export function getUserMenuTree(userType, isMember, platformType) {
  return request({
    url: '/admin/sys-menu/user-tree',
    method: 'get',
    params: { userType, isMember, platformType, _t: Date.now() },
    headers: {
      'Cache-Control': 'no-cache'
    }
  })
}

